import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';

/**
 * Cupom serializado para armazenamento offline no IndexedDB.
 *
 * O vínculo Coupon → Promotion é por convenção de código:
 * um cupom com `code = X` ativa a promoção com `code = X AND applyAutomatically = false`.
 */
export interface LocalCoupon {
  id: string;
  code: string;
  name?: string;
  description?: string;
}

/**
 * Repositório IndexedDB para cupons offline.
 *
 * O store `coupons` é populado durante a sincronização inbound
 * pelo apiCode `Coupons` (vide sync.config.ts).
 */
@Injectable({ providedIn: 'root' })
export class CouponRepository extends RepositoryBase<LocalCoupon> {
  protected readonly KEY_PATH = 'coupons';

  /** Busca um cupom pelo seu código. Retorna `undefined` se não encontrado. */
  getByCode(code: string): Observable<LocalCoupon | undefined> {
    return this.getAll().pipe(map(coupons => coupons.find(c => c.code === code)));
  }
}
